
<template>
  <router-link :to="`projects/${toSlug(title)}`" class="project">
    <ResponsiveImage v-if="coverMime === 'image'" v-bind="cover_image" @content-loaded="$emit('content-loaded')"/>
    <ResponsiveVideo v-if="coverMime === 'video'" v-bind="cover_image" autoplay />
    <h5 class="caption text-title">{{title}}</h5>
  </router-link>
</template>

<script>
import { slugFunctions } from '../mixins.js';
import ResponsiveImage from './ResponsiveImage.vue';
import ResponsiveVideo from './ResponsiveVideo.vue';

export default {
  name: 'ProjectThumbnail',
  mixins: [slugFunctions],
  components: {
    ResponsiveImage,
    ResponsiveVideo
  },
  props: {
    title: {
      required: true,
      default: 'No Title',  
    },
    date: {
      required: true, 
      default: 'No Date', 
    },
    description: {
      required: true,
      default: 'No Description', 
    },
    carousel_images: Array, 
    cover_image: Object, 
    type: String, 
    role: String, 
    tags: String, 
    github_url: String,
    website_url: String, 
  },
  computed: {
    coverMime() {
      let coverMime = this.cover_image && this.cover_image.mime && this.cover_image.mime.split('/')[0];
      if(coverMime === 'video') {
        this.$emit('content-loaded')
      }
      return coverMime; 
    }
  },
}
</script>

<style lang="sass">
.project
  display: block
  margin-bottom: 20px
  position: relative
  .image-container, .video-container
    overflow: hidden
    background: black
    img, video
      // filter: grayscale(0.5)
      opacity: 0.5
      display: block
      width: 100%
      // border: 1px solid #fff
      transition: all 150ms cubic-bezier(0, 0.666, .333, 1) 

  .caption
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    width: 200px
    text-align: center
    pointer-events: none
    opacity: 1
    color: white
    font-weight: 500

@media only screen and (min-width: 768px)
  .project
    .caption
      opacity: 0
      z-index: -1
      background: none

    .image-container, .video-container
      img, video
        opacity: 1
      &:hover 
        img, video
          filter: grayscale(0.5)
          opacity: 0.5

        ~ .caption
          z-index: 1
          opacity: 1

</style>
